import React from "react";
import { Link } from "react-router-dom";
import { CalendarDays, MapPin } from "lucide-react";
import { locationLabel } from "@/lib/mappers";
import { Avatar, AvatarFallback, AvatarImage } from "@/components/ui/avatar";
import { Badge } from "@/components/ui/badge";

const fmtDate = (iso) =>
  new Date(iso).toLocaleDateString("en-US", {
    month: "short",
    day: "numeric",
    hour: "numeric",
    minute: "2-digit",
  });

export function EventCard({ event }) {
  return (
    <Link
      to={`/event/${event.id}`}
      data-testid={`event-card-${event.id}`}
      className="group block overflow-hidden rounded-2xl border border-border bg-card shadow-sm transition-transform duration-300 ease-in-out hover:-translate-y-1 hover:shadow-md"
    >
      <div className="relative aspect-[4/3] overflow-hidden">
        <img
          src={event.cover}
          alt={event.title}
          loading="lazy"
          className="h-full w-full object-cover transition-transform duration-300 ease-in-out group-hover:scale-105"
        />
        <div className="absolute left-3 top-3">
          <Badge className="rounded-full bg-white/90 px-3 py-1 text-xs font-semibold text-foreground shadow-sm hover:bg-white">
            {event.category}
          </Badge>
        </div>
        <div className="absolute right-3 top-3">
          <Badge className="rounded-full bg-black/55 px-3 py-1 text-xs font-semibold text-white backdrop-blur-md">
            {event.price}
          </Badge>
        </div>
      </div>
      <div className="space-y-3 p-5">
        <h3 className="line-clamp-1 font-heading text-lg font-bold tracking-tight text-foreground">
          {event.title}
        </h3>
        <div className="space-y-1.5 text-sm text-muted-foreground">
          <p className="flex items-center gap-2">
            <CalendarDays className="h-4 w-4 shrink-0 text-brand" />
            {fmtDate(event.startsAt)}
          </p>
          <p className="flex items-center gap-2">
            <MapPin className="h-4 w-4 shrink-0 text-brand" />
            {locationLabel(event.location)}
          </p>
        </div>
        <div className="flex items-center gap-2 pt-1">
          <Avatar className="h-7 w-7">
            <AvatarImage src={event.host.avatar} alt={event.host.displayName} />
            <AvatarFallback>{event.host.displayName[0]}</AvatarFallback>
          </Avatar>
          <span className="text-sm font-medium text-foreground">
            {event.host.displayName}
          </span>
        </div>
      </div>
    </Link>
  );
}

export default EventCard;
